import React from 'react'

const GetOptions = ({ data, value, text, keySuffux }) => {

  return <>
    <option value="">Please Select</option>
    {
      data.map((d, i) => <option key={keySuffux + "_" + i} value={d[value]} style={d.style} disabled={!!d.disabled}>{d[text]}</option>)
    }
  </>
}

export default GetOptions